import React from "react";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import {
  CustomChartsTitle,
  CustomValue,
} from "../../components/Custom/CustomTypography";
import CustomDashboardCard from "../../components/Custom/CustomDashboard";
import { Grid, Box, Card, Container } from "@mui/material";
import CustomTransactionTable from "../../components/Custom/CustomTransactionTable";

const AuditorDashboard = () => {
  const { t } = useTranslation();
  const columns = [
    { label: "Program Name", field: "programName" },
    { label: "Date", field: "date" },
    { label: "Crop", field: "crop" },
    { label: "Action", field: "action" },
  ];

  const data = [
    // {
    //   programName: "Stubble",
    //   date: "12-10-2024",
    //   crop: "All",
    // },
  ];

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <div>
          <Grid
            container
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <Box sx={{ marginTop: "20px" }}>
              <Grid item xs={6}>
                <CustomDashboardCard title={t("TOTAL PROGRAMS")} data={"0"} />
              </Grid>
            </Box>

            <Box sx={{ marginTop: "20px" }}>
              <CustomChartsTitle>{t("Programs Details")}</CustomChartsTitle>
              <Grid container spacing={1} sx={{ padding: "10px 0" }}>
                <Grid item xs={6}>
                  <Card
                    sx={{
                      boxShadow: "none",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    <CustomValue>{t("Live Programs 0")}</CustomValue>
                  </Card>
                </Grid>
                <Grid item xs={6}>
                  <Card
                    sx={{
                      boxShadow: "none",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    <CustomValue>{t("Completed 0")}</CustomValue>
                  </Card>
                </Grid>
              </Grid>
            </Box>

            <Box>
              <Grid item xs={12} height="150px">
                <CustomTransactionTable columns={columns} data={data} />
              </Grid>
            </Box>
          </Grid>
        </div>
      </Container>
    </>
  );
};

export default AuditorDashboard;
